export const PAGE_SIZES = [10, 20, 50];

export const MAX_FIELD_LENGTH = 25;

export const GLOBAL_OPTION_VALUE = '__global__';

export const SKELETON_ROWS = Array.from({ length: 10 }, (_, i) => ({ id: i }));
